import * as FlagIcons from 'country-flag-icons/react/3x2';
import type { JSX, SVGProps } from 'react';
import { radius } from '@/shared/theme/tokens';
import Box from '../primitives/Box';
import type { SxProps, Theme } from '@mui/material/styles';

type FlagComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element;

const FLAGS = FlagIcons as Record<string, FlagComponent>;

/** 3:2 flag at text size. */
const FLAG_WIDTH = 20;
const FLAG_HEIGHT = 14;

/**
 * Clears the extra left padding MUI leaves on the text after a start adornment,
 * so the country name sits one spacing unit after the flag.
 */
export const countryFlagInputSx: SxProps<Theme> = {
  '&& .MuiOutlinedInput-input': {
    paddingLeft: 0,
  },
};

/**
 * SVG flag for an ISO 3166-1 alpha-2 code. Renders nothing when the code is unknown.
 */
const CountryFlag = ({ code }: { code: string }) => {
  const Flag = FLAGS[code.trim().toUpperCase()];
  if (!Flag) return null;

  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        lineHeight: 0,
        width: FLAG_WIDTH,
        height: FLAG_HEIGHT,
        border: 1,
        borderColor: 'divider',
        borderRadius: radius.sm,
        overflow: 'hidden',
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block',
        },
      }}
    >
      <Flag />
    </Box>
  );
};

export default CountryFlag;
